import PackagingChargesGateway from '@/gateways/PackagingChargesGateway';

function isChargesFeatureOn(features) {
  return Boolean(features) && features.charges === true;
}

export function loadKitchenChargesVisibility() {
  return PackagingChargesGateway.fetchPackagingFeatures().then(isChargesFeatureOn, () => false);
}

export default {
  data() {
    return { showKitchenCharges: false };
  },
  mounted() {
    return loadKitchenChargesVisibility().then((isVisible) => {
      this.showKitchenCharges = isVisible;
    });
  },
};
